// extracted by mini-css-extract-plugin
export default {"container":"MandateTemplate_container__IwOO2","header":"MandateTemplate_header__wcjOE","selectionPane":"MandateTemplate_selectionPane__FCqe-"};